import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import BannerSlider from "../components/BannerSlider";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../features/products/productSlice";
import axiosInstance, { base_url } from "../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import ConsultationPage from "./ConsultationPage";
import TravelPage from "./TravelPage";
import "bootstrap/dist/css/bootstrap.min.css";
import HeroSection from "./HeroSection";
import RecentltAddProducts from "./RecentltAddProducts";
import BestSelling from "../components/BestSelling";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sortedProducts, setSortedProducts] = useState([]);
  const productState = useSelector((state) => state.product.product);
  const [brands, setBrands] = useState([]);
  const [offer, setOffer] = useState([]);

  useEffect(() => {
    if (productState.length === 0) {
      dispatch(getAllProducts());
    } else {
      setSortedProducts(productState);
    }
  }, [dispatch, productState]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axiosInstance.get(`/master/getbrand`);
        const bannerData = response.data[0]?.images || [];
        setBrands(bannerData);
      } catch (error) {
        console.error("Failed to fetch brand images:", error);
      }
    };
    fetchBrands();
  }, []);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await axiosInstance.get(`/master/getoffer`);
        const bannerData = response.data[0]?.images || [];
        setOffer(bannerData);
      } catch (error) {
        console.error("Failed to fetch offer images:", error);
      }
    };
    fetchOffers();
  }, []);

  return (
    <>
      <HeroSection />

      <section className="home-wrapper-1">
        <BannerSlider />
      </section>

      <BestSelling  />

      

      <ConsultationPage />

      <section className="banner-section py-5 home-wrapper-2">
        <div className="container">
          {offer.length > 0 ? (
            offer.map((imgObj) => (
              <img
                key={imgObj._id}
                src={`${base_url}${imgObj.url}`}
                className="img-fluid w-100 rounded mb-3"
                alt="Offer Banner"
              />
            ))
          ) : (
            <p className="text-center text-muted">Loading banners...</p>
          )}
        </div>
      </section>

      <RecentltAddProducts />

      <TravelPage />

      <section className="marque-wrapper py-4 home-wrapper-2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="marquee-inner-wrapper">
                <Marquee className="d-flex">
                  {brands.length > 0 ? (
                    brands.map((brandImg) => (
                      <div
                        className="mx-4 d-flex justify-content-center align-items-center"
                        key={brandImg._id}
                      >
                        <img
                          src={`${base_url}${brandImg.url}`}
                          alt="brand"
                          className="img-fluid"
                          style={{
                            maxWidth: "100px",
                            maxHeight: "60px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ))
                  ) : (
                    <p className="text-center text-muted">Loading brands...</p>
                  )}
                </Marquee>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
